import { o365Data } from '../reporter/report/Report';
import ContentConfig from '../config/ContentConfig';
import ForbiddenError from '../error/ForbiddenError';
import RequestError from '../error/RequestError';
import getUrlPrefix from './getUrlPrefix';
import { PlayType } from '@kollective-frontend/ksdk-api';
import { SessionMetadata } from '../playback/interfaces';
import { getErrorCodeFromError } from '../interceptor/utils/dispatchErrorIngest';

export interface SessionArgs {
  contentId: string;
  contentToken: string;
  playGuid: string;
  tenantId: string;
  o365?: o365Data;
  appUser?: string;
  browserUserGuid: string;
  title: string;
  version: string;
  playType: PlayType;
  sessionMetadata: SessionMetadata;
}

function kerror(text: string, code: number): RequestError {
  // Return a modified RequestError (adding a kerror field that will be removed by the catch block)
  const error =
    code === 403 ? new ForbiddenError() : new RequestError(text, code);
  (error as unknown as Record<string, boolean>).kerror = true;
  return error;
}

export default async function startSession(
  config: ContentConfig,
  {
    contentId,
    contentToken,
    playGuid,
    tenantId,
    o365,
    appUser,
    browserUserGuid,
    sessionMetadata,
    title,
    version,
    playType
  }: SessionArgs
): Promise<void> {
  const urlPrefix = getUrlPrefix(config);
  const url = `${urlPrefix}:${config.agent.port}/tenant/${tenantId}/content/${contentId}/session/${playGuid}/create`;

  const body = JSON.stringify({
    contentToken,
    o365,
    appUser,
    browserUserGuid,
    sessionMetadata,
    title,
    version,
    playType
  });

  return await fetch(url, {
    method: 'POST',
    body
  })
    .then(resp => {
      if (resp.ok) {
        return Promise.resolve();
      }
      const { status, statusText } = resp;
      const text = statusText ?? 'Request failed';
      switch (status) {
        case 400:
          return Promise.reject(kerror('Bad Request', 400));
        case 403:
          return Promise.reject(kerror('', 403));
        default:
          return Promise.reject(kerror(text, status));
      }
    })
    .catch(e => {
      if (e.kerror) {
        delete e.kerror;
        return Promise.reject(e as Error);
      }
      const ecode = getErrorCodeFromError(e);
      return Promise.reject(new RequestError('Failed to startSession', ecode));
    });
}
